import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { Row, Col, FormGroup, Label, Card, CardBody, CardTitle, CardText } from 'reactstrap';

import ToggleField from '../../ToggleField/ToggleField';
import logo from '../../../assets/images/integrations/plausible.webp';

const PlausibleFields = () => {
    const { t }                  = useTranslation();
    const { isMobile, isTablet } = useSelector(state => state.ui);

    return (
        <div className="PlausibleFields">
            <Row>
                <Col>
                    <Card>
                        <CardBody>
                            <CardTitle className="small">
                                <img src={logo} className="img rounded" alt={t('settings.integrations.plausible.title')} />
                                { t('settings.integrations.plausible.title') }
                            </CardTitle>
                            <CardText tag="div">
                                <Row>
                                    <Col>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""}>
                                                {t("settings.integrations.plausible.enabled")}
                                            </Label>
                                            <Col lg={10}>
                                                <ToggleField name="integrations.plausible.enabled" />
                                            </Col>
                                        </FormGroup>
                                        <FormGroup row>
                                            <Label lg={2} className={ !isMobile && !isTablet ? "text-right" : ""}>
                                                {t("settings.integrations.plausible.host")}
                                            </Label>
                                            <Col lg={10}>
                                                <Field
                                                    component="input"
                                                    className="form-control"
                                                    type="url"
                                                    name="integrations.plausible.host"
                                                    id="plausible_host"
                                                    placeholder="https://analytics.netoxygen.ch"
                                                />
                                                <small className="form-text text-muted">
                                                    {t("settings.integrations.plausible.host_help")}
                                                </small>
                                            </Col>
                                        </FormGroup>
                                    </Col>
                                </Row>
                            </CardText>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default PlausibleFields;
